import { createContext, useContext } from 'react'


import { usePromoState } from '../../hooks'

import type { PromoContextValue } from '../../types'
import type { ReactNode } from 'react'

const PromoContext = createContext<PromoContextValue | null>(null)

interface PromoProviderProps {
  children: ReactNode
}

/**
 * Thin Provider - delegates all logic to usePromoState composition hook.
 */
export function PromoProvider({ children }: PromoProviderProps) {
  const state = usePromoState()

  return (
    <PromoContext value={state}>
      {children}
    </PromoContext>
  )
}

/**
 * Consumer hook for PromoContext.
 */
export function usePromo(): PromoContextValue {
  const context = useContext(PromoContext)
  if (!context) {
    throw new Error('usePromo must be used within a PromoProvider')
  }
  return context
}
